var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEventAdd(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "80px",
    height: "80px",
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 8") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Website-Copy",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Enterprise",
    transform: "translate(-913.000000, -11604.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(913.000000, 11604.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-43-Copy-8",
    fill: "#F3F3F3",
    x: 0,
    y: 0,
    width: 80,
    height: 80,
    rx: 19
  }), /*#__PURE__*/React.createElement("g", {
    id: "reshot-icon-calendar-add-2Y5KQUJ4FP",
    transform: "translate(23.000000, 23.000000)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,9.25 C0,6.3505125 2.41767,4 5.4,4 L30.6,4 C33.58242,4 36,6.3505125 36,9.25 L36,26.75 C36,29.649575 33.58242,32 30.6,32 L5.4,32 C2.41767,32 0,29.649575 0,26.75 L0,9.25 Z M5.4,7.5 C4.405896,7.5 3.6,8.28351 3.6,9.25 L3.6,26.75 C3.6,27.716525 4.405896,28.5 5.4,28.5 L30.6,28.5 C31.59414,28.5 32.4,27.716525 32.4,26.75 L32.4,9.25 C32.4,8.28351 31.59414,7.5 30.6,7.5 L5.4,7.5 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25,0 C26.1046,0 27,0.82082 27,1.83333333 L27,9.16666667 C27,10.17918 26.1046,11 25,11 C23.8954,11 23,10.17918 23,9.16666667 L23,1.83333333 C23,0.82082 23.8954,0 25,0 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11,0 C12.10456,0 13,0.82082 13,1.83333333 L13,9.16666667 C13,10.17918 12.10456,11 11,11 C9.89544,11 9,10.17918 9,9.16666667 L9,1.83333333 C9,0.82082 9.89544,0 11,0 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    points: "24 20 13 20 13 16 24 16"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    points: "16 23 16 12 20 12 20 23"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventAdd);
export default __webpack_public_path__ + "static/media/event-add.6324ad5f3d7c998269a15869324c1e29.svg";
export { ForwardRef as ReactComponent };